var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("dataScreening", {
            attrs: { propsData: { isCurrency: true, isPayChannel: true } },
            on: {
              searchChange: _vm.searchChange,
              currencyChange: _vm.currencyChange
            }
          }),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-date-picker", {
                attrs: {
                  clearable: "",
                  "picker-options": _vm.pickerOptionsRadius,
                  type: "daterange",
                  "range-separator": _vm.$t("range"),
                  "start-placeholder": _vm.$t("registerStartDate"),
                  "end-placeholder": _vm.$t("registerEndDate"),
                  "value-format": "yyyy-MM-dd",
                  align: "right"
                },
                model: {
                  value: _vm.value1,
                  callback: function($$v) {
                    _vm.value1 = $$v
                  },
                  expression: "value1"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: _vm.$t("rdOrderId") },
                model: {
                  value: _vm.searchData.order_id,
                  callback: function($$v) {
                    _vm.$set(_vm.searchData, "order_id", $$v)
                  },
                  expression: "searchData.order_id"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: _vm.$t("channelOrderId") },
                model: {
                  value: _vm.searchData.channel_order_id,
                  callback: function($$v) {
                    _vm.$set(_vm.searchData, "channel_order_id", $$v)
                  },
                  expression: "searchData.channel_order_id"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  placeholder: _vm.$t("pleaseInputUserId")
                },
                model: {
                  value: _vm.searchData.user_id,
                  callback: function($$v) {
                    _vm.$set(_vm.searchData, "user_id", $$v)
                  },
                  expression: "searchData.user_id"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  placeholder: _vm.$t("pleaseInputRoleId")
                },
                model: {
                  value: _vm.searchData.role_id,
                  callback: function($$v) {
                    _vm.$set(_vm.searchData, "role_id", $$v)
                  },
                  expression: "searchData.role_id"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  placeholder: _vm.$t("pleaseInputProductId")
                },
                model: {
                  value: _vm.searchData.product_id,
                  callback: function($$v) {
                    _vm.$set(_vm.searchData, "product_id", $$v)
                  },
                  expression: "searchData.product_id"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  placeholder: _vm.$t("pleaseInputReceiptType")
                },
                model: {
                  value: _vm.searchData.receipt_type,
                  callback: function($$v) {
                    _vm.$set(_vm.searchData, "receipt_type", $$v)
                  },
                  expression: "searchData.receipt_type"
                }
              })
            ],
            1
          ),
          _vm.rawData.game_mark.indexOf("royalpirates") > -1
            ? _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: _vm.$t("selectEnvironment")
                      },
                      on: { change: _vm.severlistChange },
                      model: {
                        value: _vm.searchData.is_prod,
                        callback: function($$v) {
                          _vm.$set(_vm.searchData, "is_prod", $$v)
                        },
                        expression: "searchData.is_prod"
                      }
                    },
                    _vm._l(_vm.severlist, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.rawData.game_mark.indexOf("royalpirates") > -1
            ? _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "",
                        "collapse-tags": "",
                        clearable: "",
                        filterable: "",
                        placeholder: _vm.$t("pleaseSelectServer")
                      },
                      on: { change: _vm.royalSeverChange },
                      model: {
                        value: _vm.searchData.server_id,
                        callback: function($$v) {
                          _vm.$set(_vm.searchData, "server_id", $$v)
                        },
                        expression: "searchData.server_id"
                      }
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: { change: _vm.selecRotAll },
                          model: {
                            value: _vm.checked,
                            callback: function($$v) {
                              _vm.checked = $$v
                            },
                            expression: "checked"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("selectAll")))]
                      ),
                      _vm._l(_vm.serverLists, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: {
                            label: item.name || item.serverName,
                            value: item.id || item.serverID
                          }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.rawData.game_mark.indexOf("yjfm") > -1
            ? _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "flex-1",
                      attrs: {
                        filterable: "",
                        placeholder: _vm.$t("selectEnvironment")
                      },
                      on: { change: _vm.envIdChangeN },
                      model: {
                        value: _vm.searchData.env_id,
                        callback: function($$v) {
                          _vm.$set(_vm.searchData, "env_id", $$v)
                        },
                        expression: "searchData.env_id"
                      }
                    },
                    _vm._l(_vm.szgmEnv, function(item) {
                      return _c("el-option", {
                        key: item.label,
                        attrs: { label: item.label, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.rawData.game_mark.indexOf("yjfm") > -1
            ? _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: _vm.$t("serverChannel")
                      },
                      on: { change: _vm.serverChange },
                      model: {
                        value: _vm.server_channel,
                        callback: function($$v) {
                          _vm.server_channel = $$v
                        },
                        expression: "server_channel"
                      }
                    },
                    _vm._l(_vm.serverChannel, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.rawData.game_mark.indexOf("yjfm") > -1
            ? _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: _vm.$t("showTestServer")
                      },
                      on: { change: _vm.serverChannelChange },
                      model: {
                        value: _vm.show_test,
                        callback: function($$v) {
                          _vm.show_test = $$v
                        },
                        expression: "show_test"
                      }
                    },
                    _vm._l(_vm.serverType, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.rawData.game_mark.indexOf("yjfm") > -1
            ? _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "",
                        "collapse-tags": "",
                        clearable: "",
                        filterable: "",
                        placeholder: _vm.$t("server")
                      },
                      on: { change: _vm.severChange },
                      model: {
                        value: _vm.searchData.server_id,
                        callback: function($$v) {
                          _vm.$set(_vm.searchData, "server_id", $$v)
                        },
                        expression: "searchData.server_id"
                      }
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: { change: _vm.selectAll },
                          model: {
                            value: _vm.checked,
                            callback: function($$v) {
                              _vm.checked = $$v
                            },
                            expression: "checked"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("selectAll")))]
                      ),
                      _vm._l(_vm.serverListYJ, function(item) {
                        return _c("el-option", {
                          key: item.serverID,
                          attrs: {
                            label: item.serverName,
                            value: item.serverID
                          }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.rawData.game_mark.indexOf("royalpirates") == -1 &&
          _vm.rawData.game_mark.indexOf("yjfm") == -1
            ? _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      filterable: "",
                      placeholder: _vm.$t("serverId")
                    },
                    model: {
                      value: _vm.searchData.server_id,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "server_id", $$v)
                      },
                      expression: "searchData.server_id"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.exportLoading,
                    disabled: !_vm.tableData.length
                  },
                  on: { click: _vm.exportdata }
                },
                [_vm._v(_vm._s(_vm.$t("export")))]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut ", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.searchClick(1)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.tableData.length
        ? _c(
            "el-table",
            {
              directives: [
                {
                  name: "sticky-table-header",
                  rawName: "v-sticky-table-header",
                  value: 0,
                  expression: "0"
                },
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.reqLoading,
                  expression: "reqLoading"
                }
              ],
              ref: "tableRef",
              attrs: { id: "tableRef", data: _vm.tableData, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "game_reveal",
                  label: _vm.$t("game"),
                  "show-overflow-tooltip": "",
                  "min-width": "150"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "platform_reveal",
                  label: _vm.$t("platform"),
                  "show-overflow-tooltip": "",
                  "min-width": "150"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "channel_reveal",
                  label: _vm.$t("channel"),
                  "show-overflow-tooltip": "",
                  "min-width": "150"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "pkg_reveal",
                  label: _vm.$t("pkg"),
                  "show-overflow-tooltip": "",
                  "min-width": "220"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "recharge_time",
                  label: _vm.$t("rechargeTime"),
                  "show-overflow-tooltip": "",
                  "min-width": "200"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "amountNew",
                  label: _vm.$t("payAmount"),
                  "show-overflow-tooltip": "",
                  "min-width": "150"
                }
              }),
              _vm.queryCurrency == "VND"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "currency_amount",
                      label: _vm.$t("payAmountUsd"),
                      "show-overflow-tooltip": "",
                      "min-width": "150"
                    }
                  })
                : _vm._e(),
              _vm.queryCurrency == "USD"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "currency_amount",
                      label: _vm.$t("payAmountVnd"),
                      "show-overflow-tooltip": "",
                      "min-width": "150"
                    }
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  prop: "ad_channel_reveal",
                  label: _vm.$t("adChannel"),
                  "show-overflow-tooltip": "",
                  "min-width": "150"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "ad_placement_reveal",
                  label: _vm.$t("adPlacement"),
                  "show-overflow-tooltip": "",
                  "min-width": "150"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "product_name",
                  label: _vm.$t("productName"),
                  "show-overflow-tooltip": "",
                  "min-width": "150"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "product_id",
                  label: _vm.$t("productId"),
                  "show-overflow-tooltip": "",
                  "min-width": "200"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var row = ref.row
                        return [
                          _c("div", { staticClass: "text-ellipsis-1" }, [
                            _vm._v(" " + _vm._s(row.product_id) + " ")
                          ])
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3979842037
                )
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "country",
                  label: _vm.$t("country"),
                  "show-overflow-tooltip": "",
                  "min-width": "150"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "order_id",
                  label: _vm.$t("rdOrderId"),
                  "show-overflow-tooltip": "",
                  "min-width": "250"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var row = ref.row
                        return [
                          _c("div", { staticClass: "text-ellipsis-1" }, [
                            _vm._v(" " + _vm._s(row.order_id) + " ")
                          ])
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1519839088
                )
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "pay_channel",
                  label: _vm.$t("payChannelLabel"),
                  "show-overflow-tooltip": "",
                  "min-width": "250"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var row = ref.row
                        return [
                          _c("div", { staticClass: "text-ellipsis-1" }, [
                            _vm._v(" " + _vm._s(row.pay_channel || "/") + " ")
                          ])
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  290548823
                )
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "pay_channel_order_id",
                  label: _vm.$t("channelOrderId"),
                  "show-overflow-tooltip": "",
                  "min-width": "280"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var row = ref.row
                        return [
                          _c("div", { staticClass: "text-ellipsis-1" }, [
                            _vm._v(" " + _vm._s(row.pay_channel_order_id) + " ")
                          ])
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  603242555
                )
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "user_id_str",
                  label: _vm.$t("userId"),
                  "show-overflow-tooltip": "",
                  "min-width": "200"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var row = ref.row
                        return [
                          _c("div", { staticClass: "text-ellipsis-1" }, [
                            _vm._v(" " + _vm._s(row.user_id_str) + " ")
                          ])
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  64428709
                )
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "role_id",
                  label: _vm.$t("roleId"),
                  "show-overflow-tooltip": "",
                  "min-width": "200"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var row = ref.row
                        return [
                          _c("div", { staticClass: "text-ellipsis-1" }, [
                            _vm._v(" " + _vm._s(row.role_id) + " ")
                          ])
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  132981642
                )
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "device_id_str",
                  label: _vm.$t("deviceId"),
                  "show-overflow-tooltip": "",
                  "min-width": "300"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var row = ref.row
                        return [
                          _c("div", { staticClass: "text-ellipsis-1" }, [
                            _vm._v(" " + _vm._s(row.device_id_str) + " ")
                          ])
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3638797996
                )
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "register_time",
                  label: _vm.$t("userRegisterTime"),
                  "show-overflow-tooltip": "",
                  "min-width": "200"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var row = ref.row
                        return [
                          _c("div", { staticClass: "text-ellipsis-1" }, [
                            _vm._v(" " + _vm._s(row.register_time || "/") + " ")
                          ])
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2166121920
                )
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "activity_time",
                  label: _vm.$t("deviceActiveTime"),
                  "show-overflow-tooltip": "",
                  "min-width": "200"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var row = ref.row
                        return [
                          _c("div", { staticClass: "text-ellipsis-1" }, [
                            _vm._v(" " + _vm._s(row.activity_time || "/") + " ")
                          ])
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  221071492
                )
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "server_id",
                  label: _vm.$t("serverId"),
                  "show-overflow-tooltip": "",
                  "min-width": "150"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "receipt_type",
                  label: _vm.$t("receiptType"),
                  "show-overflow-tooltip": "",
                  "min-width": "120"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.tableData.length
        ? _c("el-pagination", {
            attrs: {
              layout: "total,sizes, prev, pager, next",
              "current-page": _vm.searchData.page,
              total: _vm.total
            },
            on: {
              "current-change": _vm.searchClick,
              "size-change": _vm.sizeChange
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }